import React, { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const VDGridEditor = () => {
  const [form, setForm] = useState({
    // TOP RIGHT TITLE
    TopRightTitleEn: "",
    TopRightTitleAr: "",
    TopRightTitleKu: "",

    // TOP RIGHT DESC
    TopRightDescEn: "",
    TopRightDescAr: "",
    TopRightDescKu: "",

    // BOTTOM LEFT TITLE
    BottomLeftTitleEn: "",
    BottomLeftTitleAr: "",
    BottomLeftTitleKu: "",

    // BOTTOM LEFT DESC
    BottomLeftDescEn: "",
    BottomLeftDescAr: "",
    BottomLeftDescKu: "",

    // BUTTON
    ButtonTextEn: "",
    ButtonTextAr: "",
    ButtonTextKu: "",
  });

  const [images, setImages] = useState({
    topLeft: null,
    bottomRight: null,
  });

  const [loading, setLoading] = useState(true);

  // MODAL
  const [showModal, setShowModal] = useState(false);
  const [uploadField, setUploadField] = useState(null); // "topLeft" or "bottomRight"
  const [uploadFile, setUploadFile] = useState(null);

  const resolveUrl = (url) =>
    url?.startsWith("http") ? url : `${API_BASE}${url}`;

  const LANGS = ["En", "Ar", "Ku"];

  // ============================================================
  // LOAD DATA (EN + AR + KU)
  // ============================================================
  useEffect(() => {
    const load = async () => {
      try {
        const [en, ar, ku] = await Promise.all([
          axios.get(`${API_BASE}/api/VDDreamGridSection?lang=en`),
          axios.get(`${API_BASE}/api/VDDreamGridSection?lang=ar`),
          axios.get(`${API_BASE}/api/VDDreamGridSection?lang=ku`),
        ]);

        setForm({
          // TOP RIGHT TITLE
          TopRightTitleEn: en.data.topRightTitle,
          TopRightTitleAr: ar.data.topRightTitle,
          TopRightTitleKu: ku.data.topRightTitle,

          // TOP RIGHT DESC
          TopRightDescEn: en.data.topRightDesc,
          TopRightDescAr: ar.data.topRightDesc,
          TopRightDescKu: ku.data.topRightDesc,

          // BOTTOM LEFT TITLE
          BottomLeftTitleEn: en.data.bottomLeftTitle,
          BottomLeftTitleAr: ar.data.bottomLeftTitle,
          BottomLeftTitleKu: ku.data.bottomLeftTitle,

          // BOTTOM LEFT DESC
          BottomLeftDescEn: en.data.bottomLeftDesc,
          BottomLeftDescAr: ar.data.bottomLeftDesc,
          BottomLeftDescKu: ku.data.bottomLeftDesc,

          // BUTTON
          ButtonTextEn: en.data.buttonText,
          ButtonTextAr: ar.data.buttonText,
          ButtonTextKu: ku.data.buttonText,
        });

        setImages({
          topLeft: en.data.topLeftImage,
          bottomRight: en.data.bottomRightImage,
        });

        setLoading(false);
      } catch (err) {
        console.error("Failed to load VDDreamGrid:", err);
      }
    };

    load();
  }, []);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  // ============================================================
  // SAVE TEXT
  // ============================================================
  const handleSave = async () => {
    const token = localStorage.getItem("token");

    try {
      await axios.put(`${API_BASE}/api/VDDreamGridSection/13805`, form, {
        headers: { Authorization: `Bearer ${token}` },
      });

      alert("Saved successfully!");
    } catch (err) {
      console.error("SAVE FAILED", err);
      alert("Failed to save.");
    }
  };

  // ============================================================
  // DELETE IMAGE
  // ============================================================
  const deleteImage = async (field) => {
    const token = localStorage.getItem("token");

    try {
      await axios.post(
        `${API_BASE}/api/VDDreamGridSection/13805/media`,
        { [field]: null },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      alert("Image deleted (replace with new).");
      window.location.reload();
    } catch (err) {
      console.error("DELETE FAILED", err);
    }
  };

  // ============================================================
  // UPLOAD IMAGE
  // ============================================================
  const handleUpload = async () => {
    if (!uploadField || !uploadFile) return alert("Select file first.");

    const token = localStorage.getItem("token");

    const fd = new FormData();
    if (uploadField === "topLeft") fd.append("TopLeftImage", uploadFile);
    if (uploadField === "bottomRight") fd.append("BottomRightImage", uploadFile);

    try {
      await axios.post(`${API_BASE}/api/VDDreamGridSection/13805/media`, fd, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      alert("Image uploaded!");
      setShowModal(false);
      window.location.reload();
    } catch (err) {
      console.error("UPLOAD FAILED", err);
    }
  };

  if (loading) return <p>Loading...</p>;

  // ====================================================================
  // RENDER
  // ====================================================================
  return (
    <div className="container py-4">
      <h2 className="fw-bold mb-4">VOYAH DREAM – Grid Section Editor</h2>

      {/* ============================================================
          TEXT INPUTS FOR 3 LANGUAGES
      ============================================================ */}
      <div className="row">
        {LANGS.map((lang) => (
          <div key={lang} className="col-lg-4 col-md-6 mb-4">
            <div className="card shadow-sm border-0 h-100">
              <div className="card-body">
                <h5 className="text-primary">{lang}</h5>

                {/* TOP RIGHT TITLE */}
                <label className="form-label mt-3">Top Right Title</label>
                <input
                  className="form-control"
                  name={`TopRightTitle${lang}`}
                  value={form[`TopRightTitle${lang}`]}
                  onChange={handleChange}
                />

                {/* TOP RIGHT DESC */}
                <label className="form-label mt-2">Top Right Description</label>
                <textarea
                  className="form-control"
                  rows={3}
                  name={`TopRightDesc${lang}`}
                  value={form[`TopRightDesc${lang}`]}
                  onChange={handleChange}
                />

                {/* BOTTOM LEFT TITLE */}
                <label className="form-label mt-3">Bottom Left Title</label>
                <input
                  className="form-control"
                  name={`BottomLeftTitle${lang}`}
                  value={form[`BottomLeftTitle${lang}`]}
                  onChange={handleChange}
                />

                {/* BOTTOM LEFT DESC */}
                <label className="form-label mt-2">Bottom Left Description</label>
                <textarea
                  className="form-control"
                  rows={3}
                  name={`BottomLeftDesc${lang}`}
                  value={form[`BottomLeftDesc${lang}`]}
                  onChange={handleChange}
                />

                {/* BUTTON TEXT */}
                <label className="form-label mt-3">Button Text</label>
                <input
                  className="form-control"
                  name={`ButtonText${lang}`}
                  value={form[`ButtonText${lang}`]}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* SAVE BUTTON */}
      <div className="text-end mb-4">
        <button className="btn btn-primary px-4" onClick={handleSave}>
          Save Changes
        </button>
      </div>

      {/* ============================================================
          IMAGES
      ============================================================ */}
      <h4 className="mb-3">Images</h4>

      {/* TOP LEFT IMAGE */}
      <div className="card shadow-sm border-0 mb-4">
        <div className="card-body">
          <h6 className="fw-bold">Top Left Image</h6>
          {images.topLeft ? (
            <img
              src={resolveUrl(images.topLeft)}
              className="rounded w-100 mb-2"
              alt=""
              style={{ objectFit: "cover", maxHeight: "260px" }}
            />
          ) : (
            <p>No image uploaded.</p>
          )}

          <div className="d-flex gap-2">
            <button
              className="btn btn-danger"
              disabled={!images.topLeft}
              onClick={() => deleteImage("topLeft")}
            >
              Delete
            </button>
            <button
              className="btn btn-primary"
              onClick={() => {
                setUploadField("topLeft");
                setUploadFile(null);
                setShowModal(true);
              }}
            >
              Upload / Replace
            </button>
          </div>
        </div>
      </div>

      {/* BOTTOM RIGHT IMAGE */}
      <div className="card shadow-sm border-0 mb-5">
        <div className="card-body">
          <h6 className="fw-bold">Bottom Right Image</h6>
          {images.bottomRight ? (
            <img
              src={resolveUrl(images.bottomRight)}
              className="rounded w-100 mb-2"
              alt=""
              style={{ objectFit: "cover", maxHeight: "260px" }}
            />
          ) : (
            <p>No image uploaded.</p>
          )}

          <div className="d-flex gap-2">
            <button
              className="btn btn-danger"
              disabled={!images.bottomRight}
              onClick={() => deleteImage("bottomRight")}
            >
              Delete
            </button>
            <button
              className="btn btn-primary"
              onClick={() => {
                setUploadField("bottomRight");
                setUploadFile(null);
                setShowModal(true);
              }}
            >
              Upload / Replace
            </button>
          </div>
        </div>
      </div>

      {/* ============================================================
          MODAL
      ============================================================ */}
      {showModal && (
        <>
          <div className="modal fade show" style={{ display: "block" }}>
            <div className="modal-dialog">
              <div className="modal-content shadow">
                <div className="modal-header">
                  <h5 className="modal-title">Upload Image</h5>
                  <button
                    className="btn-close"
                    onClick={() => setShowModal(false)}
                  />
                </div>

                <div className="modal-body">
                  <input
                    type="file"
                    accept="image/*"
                    className="form-control"
                    onChange={(e) => setUploadFile(e.target.files[0])}
                  />
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </button>
                  <button className="btn btn-primary" onClick={handleUpload}>
                    Upload
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </div>
  );
};

export default VDGridEditor;
